import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Form } from 'react-bootstrap';
import PreviewPPD from './PreviewPPD';
import NomenclatureTable from './Nomencluture';
import { updatePPDApi, getPPDApi } from '../../../services/OtherService';
import DataLoader from '../Dashboard/Loader';
import { useParams, Link, useNavigate } from 'react-router-dom';


const EditPPDPage = () => {
    const defaultFormValue = {
        serial_no: "01",
        project_build_up: "",
        project_name_no: "",
        fbe_reference: "",
        division_demand_date: "",
        inventory_control_code: "",
        project_pdc: "",
        unit_code: "",
        major_head: "",
        minor_head: "",
        code_head: "",
        total_amount: 0,
        justification: "",
        hod_group_head_name: "",
        hod_group_head_phone: "",
        hod_group_head_date: "",
        stores_officer_name: "",
        stores_officer_phone: "",
        stores_officer_date: "",
        budget_head: "",
        budget_ic_name: "",
        budget_ic_phone: "",
        budget_ic_date: "",
        cash_purchase_officer_name: "",
        cash_purchase_officer_phone: "",
        cash_purchase_officer_designation: "",
        payment_method: "Cash",
        specimen1: "",
        specimen2: "",
        specimen3: "",
        receipt_date: "",
        certifying_officers: "",
        settlement_date: "",
        cash_officer_name: "",
        cash_officer_designation: "",
        settlement_payment_method: "Cheque",
        dv_no: "",
        cheque_no: "",
        nomenclatures: [{ nomenclature: "", unit: "", service: "", quantity: "1", cost: "" }]
    }

    const [demandForm, setDemandForm] = useState(defaultFormValue);
    const [isPreview, setIsPreview] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [colClassName, setColClassName] = useState("col-md-6")
    const [data, setData] = useState(null)
    const navigate = useNavigate()

    const { id } = useParams()

    useEffect(() => {
        setIsLoading(true)
        getPPDApi(id).then((resp) => {
            const { initiated_by, reviewed_by, approved_by, rejected_by,
                initiated_at, reviewed_at, approved_at, rejected_at,
                mmg_demand_no, division_demand_no, group_division, status,
                rejected_reason, id, nomenclatures, ...actualData } = resp.data
            const updatedData = { ...actualData, nomenclatures: nomenclatures.map(({ id, ...rest }) => rest) }
            setData(resp.data)
            setDemandForm(updatedData)
            setIsLoading(false)
        }).catch((error) => {
            console.log(error.response.data)
            setIsLoading(false)
        })

    }, [])

    const togglePreview = () => {
        setColClassName(isPreview ? "col-md-6" : "col-lg-12")
        setIsPreview(!isPreview)
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target
        setDemandForm({ ...demandForm, [name]: value })
    }

    const handleNomenclature = (data) => {
        const getTotalAmount = () => {
            return data.reduce((total, row) => {
                const quantity = parseFloat(row.quantity) || 0;
                const cost = parseFloat(row.cost) || 0;
                return total + (quantity * cost);
            }, 0);
        };
        setDemandForm({ ...demandForm, nomenclatures: data, total_amount: getTotalAmount() })
    }


    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            const response = await updatePPDApi(id, demandForm)
            const resp_data = response.data
            toast.success(resp_data?.message || "updated successfully")
            navigate(`/view-purchase-demand/${id}`)

        } catch (error) {
            console.log(error)
            if (error?.response) {
                // Extract the error message from Django's response
                const errorData = error.response.data;

                // If Django returns an error dictionary, extract the first error
                if (typeof errorData === "object") {
                    const firstErrorKey = Object.keys(errorData)[0]; // Get first error field name
                    const errorMessage = errorData[firstErrorKey]; // Get the error message

                    if (Array.isArray(errorMessage)) {
                        // If it's a list of error messages, join them
                        toast.error(errorMessage.join(", "));
                    } else {
                        // If it's a single message, show it
                        toast.error(errorMessage);
                    }
                } else {
                    // If Django returns a string error message
                    toast.error(errorData);
                }
            } else {
                // Fallback error message
                toast.error("Something went wrong. Please try again.");
            }
        };
    }


    return (
        <>
            <div className="container-fluid">
                {isLoading ? (<div className='card card-body'>
                    <DataLoader />
                </div>) :
                    <div className='row'>
                        <div className={`${isPreview ? 'col-sm-4' : 'col-sm-12'}`}>
                            <div className="card">
                                <div className='card-header d-flex align-items-center justify-content-between'>
                                    <div className="d-flex align-items-center">
                                        <Link to="/purchase-demand"
                                            className="btn btn-outline-primary btn-sm rounded-circle"
                                            style={{ padding: "5px 9px" }}
                                        ><i className="fa-solid fa-arrow-left"></i></Link>
                                        <h4 className="mb-0 ms-2">Edit PPD {data?.mmg_demand_no}</h4>
                                    </div>
                                    <div className=''>
                                        {!isPreview &&
                                            <button
                                                onClick={togglePreview}
                                                className='btn btn-outline-primary'>
                                                Show Preview</button>
                                        }
                                    </div>
                                </div>
                                <div className='card-body' style={isPreview ? { height: "calc(100vh - 180px", overflow: "auto" } : {}}>
                                    <Form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="row">
                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="project_build_up"
                                                        className="form-label">Project/Build-up
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="project_build_up"
                                                        placeholder="Enter Project/Build-up"
                                                        value={demandForm.project_build_up}
                                                        name='project_build_up'
                                                        required
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="project_name_no"
                                                        className="form-label">Project Name & NO.
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="project_name_no"
                                                        placeholder="Enter Project Name & NO."
                                                        value={demandForm.project_name_no}
                                                        name='project_name_no'
                                                        required
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="fbe_reference"
                                                        className="form-label">FBE Reference
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="fbe_reference"
                                                        placeholder="Enter FBE Reference"
                                                        value={demandForm.fbe_reference}
                                                        name='fbe_reference'
                                                        required
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="major_head"
                                                        className="form-label">Major Head
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="major_head"
                                                        placeholder="Enter Major Head"
                                                        value={demandForm.major_head}
                                                        name='major_head'
                                                        required
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="minor_head"
                                                        className="form-label">Minor Head
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="minor_head"
                                                        placeholder="Enter Minor Head"
                                                        value={demandForm.minor_head}
                                                        name='minor_head'
                                                        required
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>


                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="division_demand_date"
                                                        className="form-label">Division Demand Date
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="division_demand_date"
                                                        value={demandForm.division_demand_date}
                                                        name='division_demand_date'
                                                        required
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="inventory_control_code"
                                                        className="form-label">Inventory Control Code
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="inventory_control_code"
                                                        placeholder="Enter Inventory Control Code"
                                                        value={demandForm.inventory_control_code}
                                                        name='inventory_control_code'
                                                        required
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="project_pdc"
                                                        className="form-label">Project PDC
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="project_pdc"
                                                        placeholder="Enter Project PDC"
                                                        value={demandForm.project_pdc}
                                                        name='project_pdc'
                                                        required
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="unit_code"
                                                        className="form-label">Unit Code
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="unit_code"
                                                        placeholder="Enter Unit Code"
                                                        value={demandForm.unit_code}
                                                        name='unit_code'
                                                        required
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>


                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="code_head"
                                                        className="form-label">Code Head
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="code_head"
                                                        placeholder="Enter Code Head"
                                                        value={demandForm.code_head}
                                                        name='code_head'
                                                        required
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>
                                        </div>

                                        <h4>Nomenclatures:</h4>
                                        <NomenclatureTable rows={demandForm.nomenclatures} updateNomenclatures={handleNomenclature} />
                                        <h4>Justification:</h4>
                                        <div className="row">
                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="justification"
                                                        className="form-label">Justification
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <textarea
                                                        className="form-control"
                                                        id="justification"
                                                        placeholder="Enter Justification"
                                                        value={demandForm.justification}
                                                        name='justification'
                                                        required
                                                        onChange={handleInputChange}></textarea>
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="hod_group_head_name"
                                                        className="form-label">HOD/Group Head Name
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="hod_group_head_name"
                                                        placeholder="Enter HOD/Group Head Name"
                                                        value={demandForm.hod_group_head_name}
                                                        name='hod_group_head_name'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="hod_group_head_phone"
                                                        className="form-label">HOD/Group Head Phone
                                                    </label>
                                                    <input type="number"
                                                        className="form-control"
                                                        id="hod_group_head_phone"
                                                        placeholder="Enter HOD/Group Head Phone"
                                                        value={demandForm.hod_group_head_phone}
                                                        name='hod_group_head_phone'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="hod_group_head_date"
                                                        className="form-label">HOD/Group Head Date
                                                    </label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="hod_group_head_date"
                                                        value={demandForm.hod_group_head_date}
                                                        name='hod_group_head_date'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                        </div>
                                        <h4>Store & Budget:</h4>
                                        <div className='row'>
                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="stores_officer_name"
                                                        className="form-label">Stores Officer Name
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="stores_officer_name"
                                                        placeholder="Enter Stores Officer Name"
                                                        value={demandForm.stores_officer_name}
                                                        name='stores_officer_name'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="stores_officer_phone"
                                                        className="form-label">Stores Officer Phone
                                                    </label>
                                                    <input type="number"
                                                        className="form-control"
                                                        id="stores_officer_phone"
                                                        placeholder="Enter Stores Officer Phone"
                                                        value={demandForm.stores_officer_phone}
                                                        name='stores_officer_phone'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="stores_officer_date"
                                                        className="form-label">Stores Officer Date
                                                    </label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="stores_officer_date"
                                                        value={demandForm.stores_officer_date}
                                                        name='stores_officer_date'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="budget_head"
                                                        className="form-label">Budget Head
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="budget_head"
                                                        placeholder="Enter Budget Head"
                                                        value={demandForm.budget_head}
                                                        name='budget_head'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="budget_ic_name"
                                                        className="form-label">Budget I/C Name
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="budget_ic_name"
                                                        placeholder="Enter Budget I/C Name"
                                                        value={demandForm.budget_ic_name}
                                                        name='budget_ic_name'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="budget_ic_phone"
                                                        className="form-label">Budget I/C Phone
                                                    </label>
                                                    <input type="number"
                                                        className="form-control"
                                                        id="budget_ic_phone"
                                                        placeholder="Enter Budget I/C Phone"
                                                        value={demandForm.budget_ic_phone}
                                                        name='budget_ic_phone'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="budget_ic_date"
                                                        className="form-label">Budget I/C Date
                                                    </label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="budget_ic_date"
                                                        value={demandForm.budget_ic_date}
                                                        name='budget_ic_date'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                        </div>

                                        <h4>Cash Purchase Officer & Specimen</h4>
                                        <div className='row'>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="cash_purchase_officer_name"
                                                        className="form-label">Cash Purchase Officer Name
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="cash_purchase_officer_name"
                                                        placeholder="Enter Cash Purchase Officer Name"
                                                        value={demandForm.cash_purchase_officer_name}
                                                        name='cash_purchase_officer_name'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="cash_purchase_officer_phone"
                                                        className="form-label">Cash Purchase Officer Phone
                                                    </label>
                                                    <input type="number"
                                                        className="form-control"
                                                        id="cash_purchase_officer_phone"
                                                        placeholder="Enter Cash Purchase Officer Phone"
                                                        value={demandForm.cash_purchase_officer_phone}
                                                        name='cash_purchase_officer_phone'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="cash_purchase_officer_designation"
                                                        className="form-label">Cash Purchase Officer Designation
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="cash_purchase_officer_designation"
                                                        placeholder="Enter Cash Purchase Officer Designation"
                                                        value={demandForm.cash_purchase_officer_designation}
                                                        name='cash_purchase_officer_designation'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="specimen1"
                                                        className="form-label">First Specimen Name
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="specimen1"
                                                        placeholder="Enter First Specimen Name"
                                                        value={demandForm.specimen1}
                                                        name='specimen1'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="specimen2"
                                                        className="form-label">Second Specimen Name
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="specimen2"
                                                        placeholder="Enter Second Specimen Name"
                                                        value={demandForm.specimen2}
                                                        name='specimen2'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="specimen3"
                                                        className="form-label">Third Specimen Name
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="specimen3"
                                                        placeholder="Enter Third Specimen Name"
                                                        value={demandForm.specimen3}
                                                        name='specimen3'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label>Payment Method</label><br />
                                                    <div className="form-check custom-checkbox mb-2 form-check-inline">
                                                        <input type="radio" className="form-check-input" checked={demandForm.payment_method === "Cash"}
                                                            id="cash" name="payment_method" value={'Cash'} onChange={handleInputChange} />
                                                        <label className="form-check-label" htmlFor="cash">Cash</label>
                                                    </div>
                                                    <div className="form-check custom-checkbox mb-2 form-check-inline">
                                                        <input type="radio"
                                                            className="form-check-input"
                                                            checked={demandForm.payment_method === "Cheque"}
                                                            id="cheque" name="payment_method" value={'Cheque'} onChange={handleInputChange} />
                                                        <label className="form-check-label" htmlFor="cheque">Cheque</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <h4>Receipt & Certificate</h4>
                                        <div className='row'>
                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="receipt_date"
                                                        className="form-label">Receipt Date
                                                    </label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="receipt_date"
                                                        value={demandForm.receipt_date}
                                                        name='receipt_date'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="certifying_officers"
                                                        className="form-label">Certifying Officers
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <textarea
                                                        className="form-control"
                                                        id="certifying_officers"
                                                        placeholder="Enter Certifying Officers Name"
                                                        value={demandForm.certifying_officers}
                                                        name='certifying_officers'
                                                        required
                                                        onChange={handleInputChange}></textarea>
                                                </div>
                                            </div>
                                        </div>

                                        <h4>Settlement</h4>
                                        <div className='row'>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="cash_officer_designation"
                                                        className="form-label">Cash Officer Designation
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="cash_officer_designation"
                                                        placeholder="Enter Cash Officer Designation"
                                                        value={demandForm.cash_officer_designation}
                                                        name='cash_officer_designation'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="cash_officer_name"
                                                        className="form-label">Cash Officer Name
                                                    </label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="cash_officer_name"
                                                        placeholder="Enter Cash Officer Name"
                                                        value={demandForm.cash_officer_name}
                                                        name='cash_officer_name'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>

                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label
                                                        htmlFor="settlement_date"
                                                        className="form-label">Settlement Date
                                                    </label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="settlement_date"
                                                        value={demandForm.settlement_date}
                                                        name='settlement_date'
                                                        onChange={handleInputChange} />
                                                </div>
                                            </div>


                                            <div className={colClassName}>
                                                <div className="mb-3">
                                                    <label>Settlement Payment Method</label><br />
                                                    <div className="form-check custom-checkbox mb-2 form-check-inline">
                                                        <input type="radio"
                                                            className="form-check-input"
                                                            checked={demandForm.settlement_payment_method === "Cheque"}
                                                            id="settlementcheque" name="settlement_payment_method" value={'Cheque'} onChange={handleInputChange} />
                                                        <label className="form-check-label" htmlFor="settlementcheque">Cheque</label>
                                                    </div>
                                                    <div className="form-check custom-checkbox mb-2 form-check-inline">
                                                        <input type="radio" className="form-check-input" checked={demandForm.settlement_payment_method === "ESC/RTGS"}
                                                            id="ESC/RTGS" name="settlement_payment_method" value={'ESC/RTGS'} onChange={handleInputChange} />
                                                        <label className="form-check-label" htmlFor="ESS/RTGS">ESC / RTGS</label>
                                                    </div>
                                                </div>
                                            </div>

                                            {demandForm.settlement_payment_method === "Cheque" &&
                                                <div className={colClassName}>
                                                    <div className="mb-3">
                                                        <label
                                                            htmlFor="cheque_no"
                                                            className="form-label">Cheque No.
                                                        </label>
                                                        <input type="text"
                                                            className="form-control"
                                                            id="cheque_no"
                                                            placeholder="Enter Cheque No."
                                                            value={demandForm.cheque_no}
                                                            name='cheque_no'
                                                            onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        <div>
                                            <button type="submit" className="btn btn-primary me-1">Update</button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>

                        {isPreview && (
                            <div className='col-sm-8'>
                                <div className='card'>
                                    <div className='card-header d-flex align-items-center justify-content-between'>
                                        <h4 className='mb-0'>Preview</h4>
                                        <div className='d-flex'>
                                            <button
                                                onClick={togglePreview}
                                                className='btn btn-outline-primary'>
                                                Hide Preview</button>
                                        </div>
                                    </div>
                                    <div className='card-body' style={{ background: "#969998", height: "calc(100vh - 80px", overflow: "auto" }}>
                                        <div>
                                            <PreviewPPD props={demandForm} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                }
            </div>


        </>
    );
};

export default EditPPDPage;